// src/utils/currency.js
// The shared peso formatter (BL-082).
//
// It replaced four near-identical local copies that disagreed with each other,
// so the same negative figure read `-₱800.00` on the dashboard adjustments card
// and `₱-800.00` on the Adjustments page it links to, and the two dashboard
// cards disagreed on decimals side by side.
//
// NOT yet the app's only peso formatter — roughly a dozen local copies remain
// on payroll and employee screens (BL-082 was scoped to the adjustments and
// billing surfaces). Convert them to this rather than adding another copy.
//
// The sign goes BEFORE the symbol (`−₱800.00`) — a bare `toLocaleString` puts
// it after (`₱-800.00`), which is what the drift came from.
//
// The sign is U+2212 MINUS SIGN, not an ASCII hyphen, matching the surfaces
// this formatter feeds (AdjustmentsPage.js:416, ManualAdjustments.js:546,
// ActiveEmployeesCard.js:21). Mixing the two put `−₱1,800.00` in an
// Adjustments row directly above `-₱823.00` in its footer.
//
// It is NOT the app-wide convention yet: PayrollSummary.js and
// PayrollRunExpansion.js prepend an ASCII hyphen at nine sites, so the payroll
// wizard still shows `−₱500.00` on Adjustments and `-₱500.00` on Summary. Part of
// the same BL-082 residual as the local copies above.

/**
 * Format a peso amount with 2 decimals and a leading U+2212 minus sign.
 * `-1234.5` → `"−₱1,234.50"`. Non-numeric input formats as `"₱0.00"`.
 */
export const formatPeso = (n) => {
  const v = Number(n) || 0;
  const abs = Math.abs(v).toLocaleString("en-PH", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${v < 0 ? "−" : ""}₱${abs}`;
};
